import moment from 'moment';

export const getMonthList = () => {
  return Array.from({ length: 12 }, (_, index) => {
    const monthNumber = index + 1;
    return {
      text: moment().month(index).format('MMMM'),
      value: monthNumber
    };
  });
};

export const getYearList = () => {
  const currentYear = moment().year();
  return Array.from({ length: 10 }, (_, index) => {
    const year = currentYear - index;
    return {
      text: String(year),
      value: year
    };
  });
};
